import {CommandHandler} from './command.handler';
import {Type} from '@angular/core';


export abstract class DomainCommand {
  protected constructor(public readonly handlerClass: Type<CommandHandler>, public readonly payload: any = null) {}
}


